/**
 * Toys From TIM — storefront custom JS
 *
 * - Desktop drag-to-swipe for homepage collection circles (native overflow)
 */

(function () {
  var DRAG_THRESHOLD_PX = 8;

  function enableDragScroll(scroller) {
    if (!scroller || scroller.dataset.timDragBound === "1") return;
    scroller.dataset.timDragBound = "1";

    var isDown = false;
    var isDragging = false;
    var startX = 0;
    var startScroll = 0;
    var pointerId = null;
    var suppressClick = false;

    scroller.addEventListener(
      "pointerdown",
      function (e) {
        if (e.pointerType === "touch") return; // native touch scroll
        if (e.button !== 0) return;
        isDown = true;
        isDragging = false;
        startX = e.clientX;
        startScroll = scroller.scrollLeft;
        pointerId = e.pointerId;
      },
      { passive: true }
    );

    scroller.addEventListener("pointermove", function (e) {
      if (!isDown) return;
      var dx = e.clientX - startX;

      // Wait for a real drag before capturing / scrolling — trackpad
      // micro-jitter used to trip a 3px threshold and kill every click.
      if (!isDragging) {
        if (Math.abs(dx) < DRAG_THRESHOLD_PX) return;
        isDragging = true;
        scroller.classList.add("is-dragging");
        try {
          scroller.setPointerCapture(pointerId);
        } catch (err) {}
      }

      scroller.scrollLeft = startScroll - dx;
    });

    function endDrag(e) {
      if (!isDown) return;
      var didDrag = isDragging;
      isDown = false;
      isDragging = false;
      scroller.classList.remove("is-dragging");
      if (didDrag) {
        suppressClick = true;
        window.setTimeout(function () {
          suppressClick = false;
        }, 80);
      }
      try {
        if (e && e.pointerId != null) scroller.releasePointerCapture(e.pointerId);
      } catch (err) {}
      pointerId = null;
    }

    scroller.addEventListener("pointerup", endDrag);
    scroller.addEventListener("pointercancel", endDrag);
    scroller.addEventListener("pointerleave", function (e) {
      if (isDown) endDrag(e);
    });

    // Prevent accidental navigation after a drag
    scroller.addEventListener(
      "click",
      function (e) {
        if (!suppressClick) return;
        e.preventDefault();
        e.stopPropagation();
      },
      true
    );
  }

  function initCollectionCircleSwipe() {
    document
      .querySelectorAll(".section--collection-circles .scroller__inner")
      .forEach(enableDragScroll);
  }

  function syncCartVisibility() {
    var cartAction = document.querySelector(".header__action-item--cart");
    if (!cartAction) return;
    var countEl = cartAction.querySelector(".header__cart-count");
    var count = countEl ? parseInt(countEl.textContent, 10) : 0;
    if (isNaN(count)) count = 0;
    cartAction.classList.toggle("is-cart-empty", count === 0);
    cartAction.setAttribute("data-cart-count", String(count));
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initCollectionCircleSwipe);
  } else {
    initCollectionCircleSwipe();
  }

  document.addEventListener("shopify:section:load", initCollectionCircleSwipe);
  document.addEventListener("cart:rerendered", syncCartVisibility);
  document.documentElement.addEventListener("cart:refresh", function () {
    window.setTimeout(syncCartVisibility, 50);
  });
  syncCartVisibility();
})();
